export function removeCommas(input: string): string {
  return input.replace(/,/g, '');
}

function formatNumberWithComma(number: number | string | null | undefined) {
  if (typeof number !== 'number' && typeof number !== 'string') {
    return '0';
  }

  if (Number.isNaN(Number(number))) return '0';

  return new Intl.NumberFormat().format(Number(number));
}

export default formatNumberWithComma;
